import React from 'react'
import {Component} from 'react'
import {Title} from './components/Title'
import {Project} from './components/Project'
import {isMobile, isIPad, isDesktop} from "./Platform"
import {getMe} from './Me'
import './App.css'

export class App extends Component {
  constructor (props) {
    super(props);
    this.project = React.createRef();
    this.me = getMe();
    this.state = {pagged: false}
  }

  navClicked = (proj) => {
    this.project.current.changeProject(proj);
    // console.log('clicked');
  }

  getPlatform = () => {
    let className = 'badnano'
    
    if (isIPad()) {
      className += ' nanoAppIPad'
    }

    if (isMobile()) {
      className += ' nanoAppMobile'
    }

    if(isDesktop()) {
      className += ' nanoAppDesktop'
    }

    return(className);
  }
  
  render() {
    return(
      <div className={this.getPlatform()}>
        <div className='nanoContent'>
          <Project ref={this.project} />
          <Title navClicked={this.navClicked} />
        </div>
      </div>
    )
  }
}

export default App